module.exports = __webpack_public_path__ + "img/deux-battants.063b2de.svg";